import React, { useEffect } from 'react';
import { useLazyGetTodayAttendanceQuery } from '../../features/apis/authApi';
import DefaultIcon from '../../assets/images/profile.png';
import NoData from '../../assets/images/noregulasite.svg';
import TableSkeleton from '../../components/Skeletons/TableSkeleton';
const formatDate = (dateString: string) => {
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const year = date.getFullYear();
  return `${day}, ${month}, ${year}`;
};

function EmployeeList() {
  const [getTodayAttandance, { data, isLoading, error }] =
    useLazyGetTodayAttendanceQuery();
  useEffect(() => {
    getTodayAttandance();
  }, [getTodayAttandance]);

  return (
    <div className="h-full font-light font-inter">
      <h1 className=" text-sm md:text-xl font-semibold mb-4">Employees</h1>
      <div className="bg-white rounded-md shadow px-4 py-6">
        <div className="w-full overflow-x-auto">
          {isLoading ? (
            <div className="w-[800px] md:w-full h-[270px] overflow-y-auto hide-scrollbar">
              <TableSkeleton
                columns={[
                  { type: 'text', width: '40px' },
                  { type: 'avatar', width: '200px' },
                  { type: 'text', width: '120px' },
                  { type: 'text', width: '100px' },
                  { type: 'text', width: '100px' },
                  { type: 'badge', width: '120px' },
                ]}
                rows={5}
                className="border-none"
              />
            </div>
          ) : (
            <div className="w-[800px] md:w-full h-[270px] overflow-y-auto hide-scrollbar">
              <table className="min-w-full table-auto border-collapse">
                <thead className="text-xs">
                  <tr className="bg-[#E8E0FF]">
                    <th className="sticky top-0 py-3 px-4 bg-[#E8E0FF] z-10 text-xs text-[#444444]">
                      S.No
                    </th>
                    <th className="sticky top-0 py-3 px-2 bg-[#E8E0FF] z-10 text-left text-xs text-[#444444]">
                      Employee
                    </th>
                    <th className="sticky top-0 py-2 px-2 bg-[#E8E0FF] z-10 text-left text-xs text-[#444444]">
                      Date and Day
                    </th>
                    <th className="sticky top-0 py-2 px-2 bg-[#E8E0FF] z-10 text-left text-xs text-[#444444]">
                      Start Time
                    </th>
                    <th className="sticky top-0 py-2 px-2 bg-[#E8E0FF] z-10 text-left text-xs text-[#444444]">
                      End Time
                    </th>
                    <th className="sticky top-0 py-2 px-2 bg-[#E8E0FF] z-10 text-left text-xs text-[#444444]">
                      Availability
                    </th>
                  </tr>
                </thead>
                <tbody className="bg-white text-[11px]">
                  {error && (
                    <tr>
                      <td
                        colSpan={6}
                        className="px-4 py-2 text-center text-red-500"
                      >
                        An error occurred while fetching data.
                      </td>
                    </tr>
                  )}

                  {data?.length === 0 && !error && (
                    <tr>
                      <td colSpan={6} className="px-4 text-center">
                        <img src={NoData} className="h-52 w-full" />
                      </td>
                    </tr>
                  )}

                  {data?.map((item, index) => (
                    <tr
                      key={`${item.employee}-${index}`}
                      className="border-b-[0.5px] border-[#D4D4D4] text-xs md:text-sm"
                    >
                      <td className="px-4 py-2 text-center">{index + 1}</td>
                      <td className="px-2 py-2 flex items-center gap-2">
                        <div className="relative w-8 h-8">
                          <img
                            src={item.avatar || DefaultIcon}
                            alt={item.name}
                            className="w-8 h-8 rounded-full"
                          />
                          <span
                            className={`absolute top-0 right-0 h-2 w-2 rounded-full border-[0.5px] border-[#D4D4D4] ${
                              item.availability === 'Working'
                                ? 'bg-green-600'
                                : item.availability === 'Logout'
                                ? 'bg-[#F6DDCB]'
                                : 'bg-red-500'
                            }`}
                          />
                        </div>
                        <span>
                          {item.name
                            ?.split(' ')
                            .slice(0, 2)
                            .map(
                              (word) =>
                                word.charAt(0).toUpperCase() +
                                word.slice(1).toLowerCase()
                            )
                            .join(' ')}
                        </span>
                      </td>

                      <td className="px-2 py-2">{formatDate(item.dateAndDay)}</td>
                      <td className="px-2 py-2">{item.startTime}</td>
                      <td className="px-2 py-2">
                        {item.endTime ? (
                          item.endTime
                        ) : (
                          <span className="pl-1">---</span>
                        )}
                      </td>
                      <td className="py-2 px-2">
                        <span
                          className={`px-2 rounded py-1 text-xs ${
                            item.availability === 'Logout'
                              ? 'bg-[#F6DDCB]'
                              : 'bg-[#CBF6D5]'
                          }`}
                        >
                          {item.availability}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EmployeeList;
